// Canonical list of the 15 UI languages the web app supports. Mirrors iOS
// `Constants.swift:supportedLanguages` (code / English name / native name) and
// the codes in `create/framework-config.ts:SUPPORTED_LANGUAGES`. `en` is the
// development language and master source for every other locale.
//
// Used by the Settings UI-language picker. Order matches iOS (English first,
// then by rough usage), shown to the user by `nativeName`.

export interface UiLanguage {
  code: string;
  /** English display name (for reference / search). */
  label: string;
  /** Endonym — what speakers call the language; shown in the picker. */
  nativeName: string;
}

export const UI_LANGUAGES: UiLanguage[] = [
  { code: "en", label: "English", nativeName: "English" },
  { code: "de", label: "German", nativeName: "Deutsch" },
  { code: "fr", label: "French", nativeName: "Français" },
  { code: "es", label: "Spanish", nativeName: "Español" },
  { code: "it", label: "Italian", nativeName: "Italiano" },
  { code: "pt", label: "Portuguese", nativeName: "Português" },
  { code: "nl", label: "Dutch", nativeName: "Nederlands" },
  { code: "ja", label: "Japanese", nativeName: "日本語" },
  { code: "zh", label: "Chinese (Simplified)", nativeName: "简体中文" },
  { code: "ko", label: "Korean", nativeName: "한국어" },
  { code: "ar", label: "Arabic", nativeName: "العربية" },
  { code: "ru", label: "Russian", nativeName: "Русский" },
  { code: "hi", label: "Hindi", nativeName: "हिन्दी" },
  { code: "pl", label: "Polish", nativeName: "Polski" },
  { code: "tr", label: "Turkish", nativeName: "Türkçe" },
];

/** ISO-639-1 codes of all supported UI languages. */
export const UI_LANGUAGE_CODES: string[] = UI_LANGUAGES.map((l) => l.code);

/** Languages written right-to-left (drives `document.documentElement.dir`). */
export const RTL_LANGUAGES = new Set<string>(["ar"]);

export function isRtl(code: string): boolean {
  return RTL_LANGUAGES.has(code);
}
